module.exports = __webpack_public_path__ + "media/img/zzima714267-838a1b66.jpg";